import { Controller } from '@hotwired/stimulus'

interface HTMLElementEvent extends Event {
  target: HTMLInputElement
}

export default class RiskFilterController extends Controller {
  static targets = [
    'riskTypeCheckbox',
    'statusCheckbox',
    'ownerCheckbox',
    'inherentRiskCheckbox',
    'residualRiskCheckbox',
    'hiddenRiskType',
    'ownerSearchInput',
    'ownersList'
  ]

  declare readonly riskTypeCheckboxTargets: HTMLInputElement[]
  declare readonly statusCheckboxTargets: HTMLInputElement[]
  declare readonly ownerCheckboxTargets: HTMLInputElement[]
  declare readonly inherentRiskCheckboxTargets: HTMLInputElement[]
  declare readonly residualRiskCheckboxTargets: HTMLInputElement[]

  declare readonly hiddenRiskTypeTarget: HTMLInputElement
  declare readonly ownerSearchInputTarget: HTMLInputElement
  declare readonly ownersListTarget: HTMLElement

  declare readonly hasHiddenRiskTypeTarget: boolean
  declare readonly hasOwnerSearchInputTarget: boolean
  declare readonly hasOwnersListTarget: boolean

  handleRiskTypeChange (): void {
    const selectedValues = this.riskTypeCheckboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
    this.hiddenRiskTypeTarget.value = selectedValues.join(',')
  }

  filterOwners (event: HTMLElementEvent): void {
    const searchTerm = event.target.value.toLowerCase()
    const ownerElements = Array.from(this.ownersListTarget.querySelectorAll<HTMLElement>('[data-owner-name]'))

    ownerElements.forEach((element: HTMLElement) => {
      const ownerName = element.getAttribute('data-owner-name') ?? ''
      if (ownerName.includes(searchTerm)) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    })
  }

  reset (): void {
    const allCheckboxes: HTMLInputElement[] = [
      ...this.riskTypeCheckboxTargets,
      ...this.statusCheckboxTargets,
      ...this.ownerCheckboxTargets,
      ...this.inherentRiskCheckboxTargets,
      ...this.residualRiskCheckboxTargets
    ]

    allCheckboxes.forEach((checkbox: HTMLInputElement) => {
      checkbox.checked = false
    })

    if (this.hasOwnerSearchInputTarget) {
      this.ownerSearchInputTarget.value = ''
      const event: HTMLElementEvent = {
        target: this.ownerSearchInputTarget,
        bubbles: false,
        cancelBubble: false,
        cancelable: false,
        composed: false,
        currentTarget: null,
        defaultPrevented: false,
        eventPhase: 0,
        isTrusted: false,
        returnValue: false,
        srcElement: null,
        timeStamp: 0,
        type: '',
        composedPath: function (): EventTarget[] {
          throw new Error('Function not implemented.')
        },
        initEvent: function (type: string, bubbles?: boolean, cancelable?: boolean): void {
          throw new Error('Function not implemented.')
        },
        preventDefault: function (): void {
          throw new Error('Function not implemented.')
        },
        stopImmediatePropagation: function (): void {
          throw new Error('Function not implemented.')
        },
        stopPropagation: function (): void {
          throw new Error('Function not implemented.')
        },
        NONE: 0,
        CAPTURING_PHASE: 1,
        AT_TARGET: 2,
        BUBBLING_PHASE: 3
      }
      this.filterOwners(event)
    }

    if (this.hasHiddenRiskTypeTarget) {
      this.hiddenRiskTypeTarget.value = ''
    }
  }
}
